import { AppDate } from '../../envTypes';
import { Timestamp } from '../firebase/firebaseAccess';

/**
 * API Server time may be `{ seconds: number, nanoseconds: number }` or `string`,
 * we transformed the object to Timestamp in `src/functions/services/middlewares/FirestoreTimestampMiddleware.ts`,
 * here we need to eliminate the difference between the these two
 *
 * @param time
 */
export function apiServerTimeToAppDate(time: string | Timestamp): AppDate;
export function apiServerTimeToAppDate(
  time: undefined | string | Timestamp,
): undefined | AppDate;
export function apiServerTimeToAppDate(
  time: undefined | string | Timestamp,
): undefined | AppDate {
  if (time == null) return undefined;
  if (time instanceof Timestamp) return time;
  return Timestamp.fromDate(new Date(time));
}
